var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tabs',{class:_vm.border?'':'el-tabs-border',attrs:{"value":_vm.value,"type":_vm.type},on:{"input":_vm.onInput,"tab-click":_vm.handleClick}},[_vm._l((_vm.content),function(item,index){return (_vm.content)?_c('el-tab-pane',{key:index,attrs:{"label":item.label,"name":item.value}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")]):_vm._e()}),_vm._v(" "),(!_vm.content)?_vm._t("default"):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-27a0a578","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./UI/Tabs/index.vue
// module id = 601
// module chunks = 0